import React from 'react';

export const formatoCodigoBarras = (cell, row) => {
    // Si cell es un array, mostrar los dos primeros códigos con salto de línea
    if (Array.isArray(cell) && cell.length > 0) {
        return (
            <div>
                <div className="codigo-barras-item">
                    {cell[0].codigo}
                </div>
                {cell.length > 1 && (
                    <div className="codigo-barras-item">
                        {cell[1].codigo}
                    </div>
                )}
                {cell.length > 2 && <span className="text-muted">...</span>}
            </div>
        );
    } else {
        return "- - -";
    }
}